export enum NotExpressedType {
  None = "none",
  WaitingDocuments = "waitingDocuments",
  WaitingTestTypes = "waitingTestTypes",
}
